import React,{useState} from 'react';
import SvgXIcon from '../svg/XIcon';
import Button, {
    buttonTypes,
    buttonSizes,
    buttonTextSizes,
    buttonFunctions,
} from '../shared/Button';
import '../../scss/partials/assignDevices/assignDevices.css';
import { connect } from 'react-redux';

export function UnconnectedShowCategory(props){
    const { categoryOptionsArr,
            handleClose,
            handleSubmit, 
            submitText
        } = props;
    
    const [categoryOption, setCategoryOption] = useState([...categoryOptionsArr]);
    let btndisable = categoryOption.some( (c) => c.checked === true );

    function handleOnClickSubmit(){
        handleSubmit([...categoryOption]);
        handleClose();
    }

    function toggleCheck(indx, id){
        const categoryTemp = [...categoryOption];
        if(id === 0){
            let chk = !(categoryTemp[indx].checked);
            categoryTemp.forEach((c)=>{
                c.checked = chk;
            })
        }else{
            categoryTemp[indx].checked = !(categoryTemp[indx].checked);
            let option = categoryTemp[indx].checked;
            let temp = [...categoryTemp];
            let allRemoved = temp.slice(1);
            if(allRemoved.every((c) => c.checked)){
                categoryTemp[0].checked = true;
            }
            if(option === false && categoryTemp[0].checked){
                categoryTemp[0].checked =false;
            }
        }
        setCategoryOption([...categoryTemp]);
    }

    function getAlarmDeviceTypes(){
        return(
        <React.Fragment>
        <div className="justifyAlign-center">
            <input type="checkbox"
                className="margin-right-5"
                id="category-1"
                checked={categoryOption[0].checked}
                onChange={()=>toggleCheck(0, 0)}
                data-test="category-1"/>
            <label htmlFor="category-1" data-test="category-1-label">All Category</label>
        </div>
        <div className="grid-split">
        {categoryOption.map((each, index)=>{
            if(each.id === 0){
                return "";
            }
            else{
                return(
                <div key={index.toString()}>
                    <input type="checkbox"
                        className={index % 2 !== 0 ?"margin-right-5 margin-left-15":"margin-right-5"}  
                        checked={each.checked}
                        onChange={()=>toggleCheck(index, each.id)} 
                        data-test={"category-"+(index+1)}
                        id={"category-"+(index+1)}
                        />
                    <label htmlFor={"category-"+(index+1)} data-test={"category-"+(index+1)+"-label"}>{each.desc}</label>
                </div>
                );
            }           
        })}
        </div>
        </React.Fragment>
        );
    }

    function displayCategory(){
        if (categoryOption.length > 0 ) {
            return getAlarmDeviceTypes();
        } else {
            return (
            <div className="text-medium item-container__main-text">
                No Category To display
            </div>
            );
        }
    }

    return(
    <div className="overlay__background">
    <div className="overlay__container radius-5">
        <div className="close-window-icon-container">
            <div className="close-window-icon-button no-margin">
                <SvgXIcon onClick={handleClose} data-test="close-icon-function" />
            </div>
        </div>
        <div className="contentt-container content-container--column" >
        <h1 className="no-margin text-center" data-test="display-title">Select Category</h1>
        <hr/>
        {displayCategory()}  
        <p></p> 
        <div className="justify-center">
            <Button
                buttonFunction={buttonFunctions.submit}
                text={submitText}
                buttonType={buttonTypes.secondary}
                buttonSize={buttonSizes.extraSmall}
                buttonTextSize={buttonTextSizes.mediumSmall}
                additionalStyles="no-margin"
                disabled={!btndisable}
                onClick={handleOnClickSubmit}/>
        </div>
        </div>
    </div>
    </div>
    );
}

export default connect()(UnconnectedShowCategory);